module.exports = __webpack_public_path__ + "img/french_connection.25825dc7.jpg";